import { lazy, Suspense } from 'react';
import { Navigate, useRoutes, Outlet } from 'react-router-dom';
// config
import { PATH_AFTER_LOGIN } from 'src/config-global';
//
import { mainRoutes } from './main';
import { authRoutes } from './auth';
import { dashboardRoutes } from './dashboard';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const InvoiceListPage = lazy(() => import('src/pages/invoice/list/invoice-list-view'));
const InvoiceNewPage = lazy(() => import('src/pages/invoice/new/invoice-new-view'));
const InvoiceEditPage = lazy(() => import('src/pages/invoice/edit/invoice-edit-view'));

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: '/',
      element: <Navigate to={PATH_AFTER_LOGIN} replace />,
    },

    // Auth routes
    ...authRoutes,

    // Dashboard routes
    {
      path: 'invoice',
      element: (
        <AuthGuard>
          <DashboardLayout>
            <Suspense fallback={<LoadingScreen />}>
              <Outlet />
            </Suspense>
          </DashboardLayout>
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to="/invoice/list" replace />, index: true },
        { path: 'list', element: <InvoiceListPage /> },
        { path: 'new', element: <InvoiceNewPage /> },
        { path: ':id/edit', element: <InvoiceEditPage /> },
      ],
    },
    ...dashboardRoutes,

    // Main routes
    ...mainRoutes,

    // No match 404
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
